import React from 'react';
import { useState } from 'react';

import Spinner from '../../../core/components/spinner/spinner';

// import { AppComponent } from '../../../core/types/core-types';
import FaqAccordionItem from './faq-accordion-item';
import { FaqAccordionProps } from './faq-accordion-types';

const FaqAccordion: React.FC<FaqAccordionProps> = ({
  items,
  title,
  hasTitle,
}) => {
  const [isOpenAll, setIsOpenAll] = useState(false);

  return items?.length ? (
    <div className="faq">
      <div className={`faq__top ${hasTitle ? null : 'faq__top-only-button'}`}>
        {hasTitle ? <h2 className="faq__heading">{title}</h2> : null}
        <button className="faq__more" onClick={() => setIsOpenAll(!isOpenAll)}>
          {isOpenAll ? 'Zatvoriť všetky' : 'Otvoriť všetky'}
        </button>
      </div>
      <ul className="faq">
        {items?.map(({ name, content }, index) => (
          <FaqAccordionItem
            // eslint-disable-next-line react/no-array-index-key
            key={index}
            name={name}
            content={content}
            isOpenAll={isOpenAll}
          />
        ))}
      </ul>
    </div>
  ) : (
    <Spinner inWrapper />
  );
};

export default FaqAccordion;
